import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DrawerComponent from "../common/DrawerComponent";
import useRetakeQuizDrawer from "./useRetakeQuizDrawer";
import styles from "./styles.module.scss";
import H2Font from "../common/H2Font";
import RegFont from "../common/RegFont";
import React, { useRef, useEffect } from "react";
import RetakeQuizContent from "../RetakeQuizContent";
import RetakeQuizExtraQuestions from "../RetakeQuizExtraQuestions";
const RetakeQuizDrawer = ({ asDrawer, quizData, toggleDrawer, openDrawer, loading, submitAnswers, getUIElement, toggleNotAnsweredQuestionsDrawer, openNotAnsweredQuestionsDrawer, notAnsweredQuestions, showAnimation, }) => {
    const { isMobile, expanded, setExpanded } = useRetakeQuizDrawer(quizData);
    const ref = useRef(null);
    const extraRef = useRef(null);
    useEffect(() => {
        if (openDrawer && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
            setExpanded(quizData.map((question) => question.questionName));
        }
        if (openDrawer && !asDrawer) {
            toggleDrawer(true)();
        }
    }, [openDrawer]);
    useEffect(() => {
        if (!openDrawer) {
            quizData.forEach((item) => {
                expanded[item.title] = false;
            });
        }
    }, [openDrawer, quizData]);
    const submit = async () => {
        if (ref.current) {
            ref.current.scrollIntoView();
        }
        if (extraRef.current) {
            extraRef.current.scrollIntoView();
        }
        await submitAnswers();
    };
    return (_jsx(_Fragment, { children: asDrawer ? (_jsxs(_Fragment, { children: [_jsx(DrawerComponent, { anchor: isMobile ? "bottom" : "right", toggleDrawer: toggleNotAnsweredQuestionsDrawer, open: openNotAnsweredQuestionsDrawer, extraClassName: styles.drawer, crossButton: !showAnimation, drawerClassName: showAnimation && styles.overflow_hidden, children: _jsx(RetakeQuizExtraQuestions, { quizData: quizData, loading: loading, submitAnswers: submitAnswers, showAnimation: showAnimation, notAnsweredQuestions: notAnsweredQuestions, getUIElement: getUIElement }) }), _jsxs(DrawerComponent, { anchor: isMobile ? "bottom" : "right", toggleDrawer: toggleDrawer, open: openDrawer, extraClassName: styles.drawer, crossButton: !showAnimation, drawerClassName: showAnimation && styles.overflow_hidden, children: [_jsxs("div", { className: styles.drawerheader, children: [_jsx(H2Font, { children: "About you" }), _jsx(RegFont, { children: "Feel free to change your responses so we can personalize your blends to your preferences" })] }), _jsx(RetakeQuizContent, { quizData: quizData, loading: loading, submitAnswers: submitAnswers, getUIElement: getUIElement, showAnimation: showAnimation })] })] })) : (_jsxs(_Fragment, { children: [openNotAnsweredQuestionsDrawer && (_jsx(RetakeQuizExtraQuestions, { quizData: quizData, loading: loading, submitAnswers: submitAnswers, showAnimation: showAnimation, notAnsweredQuestions: notAnsweredQuestions, getUIElement: getUIElement })), openDrawer && !openNotAnsweredQuestionsDrawer && (_jsx(RetakeQuizContent, { quizData: quizData, loading: loading, submitAnswers: submitAnswers, getUIElement: getUIElement, showAnimation: showAnimation }))] })) }));
};
export default RetakeQuizDrawer;
